/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SplatRouteImport } from './routes/$'
import { Route as CasesRouteImport } from './routes/cases'
import { Route as ChecksRouteImport } from './routes/checks'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as PartiesRouteImport } from './routes/parties'
import { Route as ProfilesRouteImport } from './routes/profiles'
import { Route as ReportsRouteImport } from './routes/reports'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as SourcesRouteImport } from './routes/sources'
import { Route as EventsIndexRouteImport } from './routes/events.index'
import { Route as EventsIdRouteImport } from './routes/events.$id'
import { Route as OrganizationsIdRouteImport } from './routes/organizations.$id'
import { Route as PeopleIndexRouteImport } from './routes/people.index'
import { Route as PeopleIdRouteImport } from './routes/people.$id'
import { Route as ResearchProfilesIndexRouteImport } from './routes/research-profiles.index'
import { Route as ResearchProfilesIdRouteImport } from './routes/research-profiles.$id'
import { Route as ResearchProfilesNewRouteImport } from './routes/research-profiles.new'
import { Route as SharedTokenRouteImport } from './routes/shared.$token'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const SplatRoute = SplatRouteImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => rootRouteImport,
} as any)
const CasesRoute = CasesRouteImport.update({
  id: '/cases',
  path: '/cases',
  getParentRoute: () => rootRouteImport,
} as any)
const ChecksRoute = ChecksRouteImport.update({
  id: '/checks',
  path: '/checks',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRoute = DashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const PartiesRoute = PartiesRouteImport.update({
  id: '/parties',
  path: '/parties',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfilesRoute = ProfilesRouteImport.update({
  id: '/profiles',
  path: '/profiles',
  getParentRoute: () => rootRouteImport,
} as any)
const ReportsRoute = ReportsRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const SourcesRoute = SourcesRouteImport.update({
  id: '/sources',
  path: '/sources',
  getParentRoute: () => rootRouteImport,
} as any)
const EventsIndexRoute = EventsIndexRouteImport.update({
  id: '/events/',
  path: '/events/',
  getParentRoute: () => rootRouteImport,
} as any)
const EventsIdRoute = EventsIdRouteImport.update({
  id: '/events/$id',
  path: '/events/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const OrganizationsIdRoute = OrganizationsIdRouteImport.update({
  id: '/organizations/$id',
  path: '/organizations/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const PeopleIndexRoute = PeopleIndexRouteImport.update({
  id: '/people/',
  path: '/people/',
  getParentRoute: () => rootRouteImport,
} as any)
const PeopleIdRoute = PeopleIdRouteImport.update({
  id: '/people/$id',
  path: '/people/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const ResearchProfilesIndexRoute = ResearchProfilesIndexRouteImport.update({
  id: '/research-profiles/',
  path: '/research-profiles/',
  getParentRoute: () => rootRouteImport,
} as any)
const ResearchProfilesIdRoute = ResearchProfilesIdRouteImport.update({
  id: '/research-profiles/$id',
  path: '/research-profiles/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const ResearchProfilesNewRoute = ResearchProfilesNewRouteImport.update({
  id: '/research-profiles/new',
  path: '/research-profiles/new',
  getParentRoute: () => rootRouteImport,
} as any)
const SharedTokenRoute = SharedTokenRouteImport.update({
  id: '/shared/$token',
  path: '/shared/$token',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/$': typeof SplatRoute
  '/cases': typeof CasesRoute
  '/checks': typeof ChecksRoute
  '/dashboard': typeof DashboardRoute
  '/parties': typeof PartiesRoute
  '/profiles': typeof ProfilesRoute
  '/reports': typeof ReportsRoute
  '/settings': typeof SettingsRoute
  '/sources': typeof SourcesRoute
  '/events/$id': typeof EventsIdRoute
  '/organizations/$id': typeof OrganizationsIdRoute
  '/people/$id': typeof PeopleIdRoute
  '/research-profiles/$id': typeof ResearchProfilesIdRoute
  '/research-profiles/new': typeof ResearchProfilesNewRoute
  '/shared/$token': typeof SharedTokenRoute
  '/events/': typeof EventsIndexRoute
  '/people/': typeof PeopleIndexRoute
  '/research-profiles/': typeof ResearchProfilesIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/$': typeof SplatRoute
  '/cases': typeof CasesRoute
  '/checks': typeof ChecksRoute
  '/dashboard': typeof DashboardRoute
  '/parties': typeof PartiesRoute
  '/profiles': typeof ProfilesRoute
  '/reports': typeof ReportsRoute
  '/settings': typeof SettingsRoute
  '/sources': typeof SourcesRoute
  '/events/$id': typeof EventsIdRoute
  '/organizations/$id': typeof OrganizationsIdRoute
  '/people/$id': typeof PeopleIdRoute
  '/research-profiles/$id': typeof ResearchProfilesIdRoute
  '/research-profiles/new': typeof ResearchProfilesNewRoute
  '/shared/$token': typeof SharedTokenRoute
  '/events': typeof EventsIndexRoute
  '/people': typeof PeopleIndexRoute
  '/research-profiles': typeof ResearchProfilesIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/$': typeof SplatRoute
  '/cases': typeof CasesRoute
  '/checks': typeof ChecksRoute
  '/dashboard': typeof DashboardRoute
  '/parties': typeof PartiesRoute
  '/profiles': typeof ProfilesRoute
  '/reports': typeof ReportsRoute
  '/settings': typeof SettingsRoute
  '/sources': typeof SourcesRoute
  '/events/$id': typeof EventsIdRoute
  '/organizations/$id': typeof OrganizationsIdRoute
  '/people/$id': typeof PeopleIdRoute
  '/research-profiles/$id': typeof ResearchProfilesIdRoute
  '/research-profiles/new': typeof ResearchProfilesNewRoute
  '/shared/$token': typeof SharedTokenRoute
  '/events/': typeof EventsIndexRoute
  '/people/': typeof PeopleIndexRoute
  '/research-profiles/': typeof ResearchProfilesIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/$'
    | '/cases'
    | '/checks'
    | '/dashboard'
    | '/parties'
    | '/profiles'
    | '/reports'
    | '/settings'
    | '/sources'
    | '/events/$id'
    | '/organizations/$id'
    | '/people/$id'
    | '/research-profiles/$id'
    | '/research-profiles/new'
    | '/shared/$token'
    | '/events/'
    | '/people/'
    | '/research-profiles/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/$'
    | '/cases'
    | '/checks'
    | '/dashboard'
    | '/parties'
    | '/profiles'
    | '/reports'
    | '/settings'
    | '/sources'
    | '/events/$id'
    | '/organizations/$id'
    | '/people/$id'
    | '/research-profiles/$id'
    | '/research-profiles/new'
    | '/shared/$token'
    | '/events'
    | '/people'
    | '/research-profiles'
  id:
    | '__root__'
    | '/'
    | '/$'
    | '/cases'
    | '/checks'
    | '/dashboard'
    | '/parties'
    | '/profiles'
    | '/reports'
    | '/settings'
    | '/sources'
    | '/events/$id'
    | '/organizations/$id'
    | '/people/$id'
    | '/research-profiles/$id'
    | '/research-profiles/new'
    | '/shared/$token'
    | '/events/'
    | '/people/'
    | '/research-profiles/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  SplatRoute: typeof SplatRoute
  CasesRoute: typeof CasesRoute
  ChecksRoute: typeof ChecksRoute
  DashboardRoute: typeof DashboardRoute
  PartiesRoute: typeof PartiesRoute
  ProfilesRoute: typeof ProfilesRoute
  ReportsRoute: typeof ReportsRoute
  SettingsRoute: typeof SettingsRoute
  SourcesRoute: typeof SourcesRoute
  EventsIdRoute: typeof EventsIdRoute
  OrganizationsIdRoute: typeof OrganizationsIdRoute
  PeopleIdRoute: typeof PeopleIdRoute
  ResearchProfilesIdRoute: typeof ResearchProfilesIdRoute
  ResearchProfilesNewRoute: typeof ResearchProfilesNewRoute
  SharedTokenRoute: typeof SharedTokenRoute
  EventsIndexRoute: typeof EventsIndexRoute
  PeopleIndexRoute: typeof PeopleIndexRoute
  ResearchProfilesIndexRoute: typeof ResearchProfilesIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$': {
      id: '/$'
      path: '/$'
      fullPath: '/$'
      preLoaderRoute: typeof SplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cases': {
      id: '/cases'
      path: '/cases'
      fullPath: '/cases'
      preLoaderRoute: typeof CasesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/checks': {
      id: '/checks'
      path: '/checks'
      fullPath: '/checks'
      preLoaderRoute: typeof ChecksRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard': {
      id: '/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/parties': {
      id: '/parties'
      path: '/parties'
      fullPath: '/parties'
      preLoaderRoute: typeof PartiesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profiles': {
      id: '/profiles'
      path: '/profiles'
      fullPath: '/profiles'
      preLoaderRoute: typeof ProfilesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reports': {
      id: '/reports'
      path: '/reports'
      fullPath: '/reports'
      preLoaderRoute: typeof ReportsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sources': {
      id: '/sources'
      path: '/sources'
      fullPath: '/sources'
      preLoaderRoute: typeof SourcesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/events/': {
      id: '/events/'
      path: '/events'
      fullPath: '/events/'
      preLoaderRoute: typeof EventsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/events/$id': {
      id: '/events/$id'
      path: '/events/$id'
      fullPath: '/events/$id'
      preLoaderRoute: typeof EventsIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/organizations/$id': {
      id: '/organizations/$id'
      path: '/organizations/$id'
      fullPath: '/organizations/$id'
      preLoaderRoute: typeof OrganizationsIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/people/': {
      id: '/people/'
      path: '/people'
      fullPath: '/people/'
      preLoaderRoute: typeof PeopleIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/people/$id': {
      id: '/people/$id'
      path: '/people/$id'
      fullPath: '/people/$id'
      preLoaderRoute: typeof PeopleIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/research-profiles/': {
      id: '/research-profiles/'
      path: '/research-profiles'
      fullPath: '/research-profiles/'
      preLoaderRoute: typeof ResearchProfilesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/research-profiles/$id': {
      id: '/research-profiles/$id'
      path: '/research-profiles/$id'
      fullPath: '/research-profiles/$id'
      preLoaderRoute: typeof ResearchProfilesIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/research-profiles/new': {
      id: '/research-profiles/new'
      path: '/research-profiles/new'
      fullPath: '/research-profiles/new'
      preLoaderRoute: typeof ResearchProfilesNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/shared/$token': {
      id: '/shared/$token'
      path: '/shared/$token'
      fullPath: '/shared/$token'
      preLoaderRoute: typeof SharedTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  SplatRoute: SplatRoute,
  CasesRoute: CasesRoute,
  ChecksRoute: ChecksRoute,
  DashboardRoute: DashboardRoute,
  PartiesRoute: PartiesRoute,
  ProfilesRoute: ProfilesRoute,
  ReportsRoute: ReportsRoute,
  SettingsRoute: SettingsRoute,
  SourcesRoute: SourcesRoute,
  EventsIdRoute: EventsIdRoute,
  OrganizationsIdRoute: OrganizationsIdRoute,
  PeopleIdRoute: PeopleIdRoute,
  ResearchProfilesIdRoute: ResearchProfilesIdRoute,
  ResearchProfilesNewRoute: ResearchProfilesNewRoute,
  SharedTokenRoute: SharedTokenRoute,
  EventsIndexRoute: EventsIndexRoute,
  PeopleIndexRoute: PeopleIndexRoute,
  ResearchProfilesIndexRoute: ResearchProfilesIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
